import { render, staticRenderFns } from "./Ecommerce-Solutions.vue?vue&type=template&id=4b38021c&scoped=true"
import script from "./Ecommerce-Solutions.vue?vue&type=script&lang=js"
export * from "./Ecommerce-Solutions.vue?vue&type=script&lang=js"
import style0 from "./Ecommerce-Solutions.vue?vue&type=style&index=0&id=4b38021c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b38021c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsFeatures: require('/home/rohit/Documents/GitHub/aibuddha-website/components/ProductsFeatures.vue').default,Testimonials: require('/home/rohit/Documents/GitHub/aibuddha-website/components/Testimonials.vue').default,MidBanner: require('/home/rohit/Documents/GitHub/aibuddha-website/components/MidBanner.vue').default})
